import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './i18n'

// Inject HubSpot tracking script only when VITE_ENABLE_HUBSPOT_SCRIPT=true.
// Disable when Cloudflare Zaraz is managing HubSpot to prevent duplicate loads.
if (import.meta.env.VITE_ENABLE_HUBSPOT_SCRIPT === 'true') {
  const hsScript = document.createElement('script');
  hsScript.type = 'text/javascript';
  hsScript.id = 'hs-script-loader';
  hsScript.async = true;
  hsScript.defer = true;
  hsScript.src = `https://js.hs-scripts.com/${import.meta.env.VITE_HUBSPOT_PORTAL_ID}.js`;
  document.body.appendChild(hsScript);
}

createRoot(document.getElementById("root")!).render(
  <App />
);
